module.exports = __webpack_public_path__ + "static/media/lithonia-urgent-care.39017d3b.jpeg";